import STORAGE_KEYS from "constants/storage";

const isContrastTurnOn = () => localStorage.getItem( STORAGE_KEYS.CONTRAST ) === "on";

export const checkContrastAtStart = () => isContrastTurnOn() && turnOnContrast();

export const turnOnContrast = () => {
	localStorage.setItem( STORAGE_KEYS.CONTRAST, "on" );
	document.body.classList.add("contrast");
}


export const turnOffContrast = () => {
	localStorage.setItem( STORAGE_KEYS.CONTRAST, "off" );
	document.body.classList.remove("contrast");
}


export const toggleContrast = () => {
	!isContrastTurnOn() 
		? turnOnContrast()
		: turnOffContrast();
}


export const changeFontSize = action => {

	if ( ![ "less", "normal", "more" ].includes( action )) return;

	const body = document.body;
	let fontSize = parseInt( window.getComputedStyle( body ).fontSize.replace( "px", "" ));
	
	if ( action === 'less' && fontSize > 10 ) fontSize -= 1;
	if ( action === 'more' && fontSize < 18 ) fontSize += 1;
	if ( action === "normal") fontSize = 14;

	fontSize += "px";
	body.style.fontSize = fontSize;
};
